var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M31,31.33H14A.93.93,0,0,1,13.21,30L21.69,14.1a1,1,0,0,1,1.62,0L31.79,30A.93.93,0,0,1,31,31.33ZM15.54,29.5H29.46l-7-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.36,27.1a.86.86,0,0,1-.25.61.85.85,0,0,1-1.45-.61.81.81,0,0,1,.24-.59.88.88,0,0,1,1.21,0A.82.82,0,0,1,23.36,27.1Zm-.17-1.94a.67.67,0,0,1-.19.49.7.7,0,0,1-.49.19.67.67,0,0,1-.69-.68V21.5A.66.66,0,0,1,22,21a.64.64,0,0,1,.49-.19.65.65,0,0,1,.68.68Z",
    fill: "#e7e7e7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.a11d78fe2ae0179ccaaa0da10bdbb5f8.svg";
export { ForwardRef as ReactComponent };